module.exports = __webpack_public_path__ + "static/img/sugar.3cb61d88.png";